// Magic numbers from the server: 1 = Approved, 6 = Pending, 7 = Declined
export const PAR_ITEM_APPROVED = 1;
export const PAR_ITEM_PENDING = 6;
export const PAR_ITEM_DECLINED = 7;
